import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { ToastContainer } from "react-toastify";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

import "react-toastify/dist/ReactToastify.css";
import "./global.css";

const baseUrl = document
  .getElementsByTagName("base")[0]
  .getAttribute("href") as string;
export const history = createBrowserHistory({ basename: baseUrl });

const store = configureStore(history);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// A single, compact type scale so every page shares consistent titles, headings,
// body and captions. Weights are standardized on 600 for "bold"/"medium" so the
// mix of "bold"/600/500 across the app renders uniformly.
const theme = createTheme({
  palette: {
    primary: {
      main: "#032e5b",
    },
  },
  typography: {
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h3: { fontSize: "2rem", fontWeight: 600 }, // 32px — page titles (PageHero)
    h4: { fontSize: "1.5rem", fontWeight: 600 }, // 24px
    h5: { fontSize: "1.25rem", fontWeight: 600 }, // 20px — section headings
    h6: { fontSize: "1.0625rem", fontWeight: 500 }, // 17px — card/dialog titles
    subtitle1: { fontSize: "1rem", fontWeight: 500 }, // 16px
    subtitle2: { fontSize: "0.875rem", fontWeight: 500 }, // 14px
    body1: { fontSize: "1rem", fontWeight: 400 }, // 16px
    body2: { fontSize: "0.875rem", fontWeight: 400 }, // 14px
    caption: { fontSize: "0.75rem", fontWeight: 400 }, // 12px
  },
  overrides: {
    // Every tab bar sits on the same light brand-blue background (replaces the
    // old grey AppBar look), for a consistent look across all pages.
    MuiTabs: {
      root: {
        backgroundColor: "#e7eef7",
        borderRadius: 4,
      },
    },
    // The dashboards wrap their Tabs in a grey `color="default"` AppBar; recolor it
    // to the same light brand-blue (and drop the shadow) so it matches the plain
    // Tabs on every other page. The primary nav bar (color="primary") is unaffected.
    MuiAppBar: {
      colorDefault: {
        backgroundColor: "#e7eef7",
        boxShadow: "none",
      },
    },
  },
});

ReactDOM.render(
  <Provider store={store}>
    <ToastContainer
      position="top-right"
      autoClose={2000}
      hideProgressBar={false}
      closeOnClick
      style={{ width: "40%" }}
    />
    <ConnectedRouter history={history}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);

registerServiceWorker();
